import React, { useState } from 'react'
import {
    FormControl,
    InputLabel,
    MenuItem,
    Select,
    SelectChangeEvent,
} from "@mui/material";
import { QuarterFilterProps } from '../../types/types';
import { TranslationEnum, usePortalTranslation } from '../../../../providers/TranslationProvider';
import { useSelector } from 'react-redux';
import store from '../../../../stateManagement/store';

const QuarterFilter = (props: QuarterFilterProps) => {
    const koFilter = useSelector(() => Boolean(store.getState()?.fileFormat?.config?.useBusinessCalendar));
    const { translate } = usePortalTranslation();
    // const handleChangePeriod = (event: SelectChangeEvent) => {
    //     props.setQuarter(event.target.value);
    // };
    return (
        <div className="dates-periodrange" style={{margin:"0px",padding:"10px"}}>
            {/* <FormControl>
                <InputLabel id="demo-simple-select-label">{translate(TranslationEnum.common_portal, "Quarter")}</InputLabel>
                <Select
                    labelId="demo-simple-select-label"
                    id="demo-simple-select"
                    value={props.quarter}
                    label={translate(TranslationEnum.common_portal, "Quarter")}
                    onChange={handleChangePeriod}
                >
                    {props.quarterOptions.map((option: any) => (
                        <MenuItem key={option} value={option}>
                            {option}
                        </MenuItem>
                    ))}
                </Select>
            </FormControl> */}
            <FormControl>
                <InputLabel id="demo-simple-select-label">{translate(TranslationEnum.common_portal, "Year")}</InputLabel>
                <Select
                    labelId="demo-simple-select-label"
                    id="demo-simple-select"
                    value={props.year}
                    label={translate(TranslationEnum.common_portal, "Year")}
                    onChange={props.handleChangeYear}
                >
                    {props.yearOptions.map((year) => {
                        return <MenuItem value={year}>{year}</MenuItem>
                    })}
                </Select>
            </FormControl>
        </div>
    )
}

export default QuarterFilter